// extracted by mini-css-extract-plugin
export default {"button":"GoogleAuth_button__n0g3J","buttonLabel":"GoogleAuth_buttonLabel__mYNCs"};